import { combineReducers } from 'redux';
import { notification } from '@breezeway/brzw-react-core';

export default combineReducers({
  toasts: notification.reducers.toasts,
  toastsV2: notification.reducers.toastsV2,
  userAlerts: notification.reducers.userAlerts,
});
